export const ICONS = {
  x: () => import('../iconify-icons/mingcute/close-line.js'),
  heart: () => import('../iconify-icons/mingcute/heart-line.js'),
  bookmark: () => import('../iconify-icons/mingcute/bookmark-line.js'),
  'check-circle': () =>
    import('../iconify-icons/mingcute/check-circle-line.js'),
  'x-circle': () => import('../iconify-icons/mingcute/close-circle-line.js'),
  transfer: () => import('../iconify-icons/mingcute/transfer-4-line.js'),
  rocket: () => import('../iconify-icons/mingcute/rocket-line.js'),
  'arrow-left': {
    module: () => import('../iconify-icons/mingcute/arrow-left-line.js'),
    rtl: true,
  },
  'arrow-right': {
    module: () => import('../iconify-icons/mingcute/arrow-right-line.js'),
    rtl: true,
  },
  'arrow-up': () => import('../iconify-icons/mingcute/arrow-up-line.js'),
  'arrow-down': () => import('../iconify-icons/mingcute/arrow-down-line.js'),
  earth: () => import('../iconify-icons/mingcute/world-2-line.js'),
  lock: () => import('../iconify-icons/mingcute/lock-line.js'),
  unlock: () => import('../iconify-icons/mingcute/unlock-line.js'),
  'eye-close': () => import('../iconify-icons/mingcute/eye-close-line.js'),
  'eye-open': () => import('../iconify-icons/mingcute/eye-2-line.js'),
  message: () => import('../iconify-icons/mingcute/mail-line.js'),
  comment: {
    module: () => import('../iconify-icons/mingcute/chat-3-line.js'),
    rtl: true,
  },
  comment2: {
    module: () => import('../iconify-icons/mingcute/comment-2-line.js'),
    rtl: true,
  },
  home: () => import('../iconify-icons/mingcute/home-3-line.js'),
  notification: () => import('../iconify-icons/mingcute/notification-line.js'),
  follow: () => import('../iconify-icons/mingcute/user-follow-line.js'),
  'follow-add': () => import('../iconify-icons/mingcute/user-add-line.js'),
  poll: [() => import('../iconify-icons/mingcute/chart-bar-line.js'), '90deg'],
  pencil: () => import('../iconify-icons/mingcute/pencil-line.js'),
  quill: () => import('../iconify-icons/mingcute/quill-pen-line.js'),
  at: () => import('../iconify-icons/mingcute/at-line.js'),
  attachment: () => import('../iconify-icons/mingcute/attachment-line.js'),
  upload: () => import('../iconify-icons/mingcute/upload-3-line.js'),
  gear: () => import('../iconify-icons/mingcute/settings-3-line.js'),
  more: () => import('../iconify-icons/mingcute/more-3-line.js'),
  more2: () => import('../iconify-icons/mingcute/more-1-fill.js'),
  external: {
    module: () => import('../iconify-icons/mingcute/external-link-line.js'),
    rtl: true,
  },
  popout: {
    module: () => import('../iconify-icons/mingcute/external-link-line.js'),
    rtl: true,
  },
  popin: {
    module: () => import('../iconify-icons/mingcute/external-link-line.js'),
    rotate: '180deg',
    rtl: true,
  },
  plus: () => import('../iconify-icons/mingcute/add-circle-line.js'),
  'chevron-left': {
    module: () => import('../iconify-icons/mingcute/left-line.js'),
    rtl: true,
  },
  'chevron-right': {
    module: () => import('../iconify-icons/mingcute/right-line.js'),
    rtl: true,
  },
  'chevron-down': () => import('../iconify-icons/mingcute/down-line.js'),
  reply: {
    module: () => import('../iconify-icons/mingcute/share-forward-line.js'),
    rotate: '180deg',
    flip: 'horizontal',
    rtl: true,
  },
  thread: () => import('../iconify-icons/mingcute/route-line.js'),
  group: {
    module: () => import('../iconify-icons/mingcute/group-line.js'),
    rtl: true,
  },
  bot: () => import('../iconify-icons/mingcute/android-2-line.js'),
  menu: () => import('../iconify-icons/mingcute/rows-4-line.js'),
  list: {
    module: () => import('../iconify-icons/mingcute/list-check-line.js'),
    rtl: true,
  },
  search: () => import('../iconify-icons/mingcute/search-2-line.js'),
  hashtag: () => import('../iconify-icons/mingcute/hashtag-line.js'),
  info: () => import('../iconify-icons/mingcute/information-line.js'),
  shortcut: () => import('../iconify-icons/mingcute/lightning-line.js'),
  user: () => import('../iconify-icons/mingcute/user-4-line.js'),
  following: () => import('../iconify-icons/mingcute/walk-line.js'),
  pin: () => import('../iconify-icons/mingcute/pin-line.js'),
  unpin: [() => import('../iconify-icons/mingcute/pin-line.js'), '180deg'],
  bus: () => import('../iconify-icons/mingcute/bus-2-line.js'),
  link: () => import('../iconify-icons/mingcute/link-2-line.js'),
  history: () => import('../iconify-icons/mingcute/history-line.js'),
  share: () => import('../iconify-icons/mingcute/share-2-line.js'),
  sparkles: () => import('../iconify-icons/mingcute/sparkles-line.js'),
  sparkles2: () => import('../iconify-icons/mingcute/sparkles-2-line.js'),
  exit: {
    module: () => import('../iconify-icons/mingcute/exit-line.js'),
    rtl: true,
  },
  translate: () => import('../iconify-icons/mingcute/translate-line.js'),
  play: () => import('../iconify-icons/mingcute/play-fill.js'),
  trash: () => import('../iconify-icons/mingcute/delete-2-line.js'),
  mute: {
    module: () => import('../iconify-icons/mingcute/volume-mute-line.js'),
    rtl: true,
  },
  unmute: {
    module: () => import('../iconify-icons/mingcute/volume-line.js'),
    rtl: true,
  },
  block: () => import('../iconify-icons/mingcute/forbid-circle-line.js'),
  unblock: [
    () => import('../iconify-icons/mingcute/forbid-circle-line.js'),
    '180deg',
  ],
  flag: () => import('../iconify-icons/mingcute/flag-1-line.js'),
  time: () => import('../iconify-icons/mingcute/time-line.js'),
  refresh: () => import('../iconify-icons/mingcute/refresh-2-line.js'),
  emoji2: () => import('../iconify-icons/mingcute/emoji-2-line.js'),
  filter: () => import('../iconify-icons/mingcute/filter-2-line.js'),
  filters: () => import('../iconify-icons/mingcute/filter-line.js'),
  chart: () => import('../iconify-icons/mingcute/chart-line-line.js'),
  react: () => import('../iconify-icons/mingcute/react-line.js'),
  layout4: {
    module: () => import('../iconify-icons/mingcute/layout-4-line.js'),
    rtl: true,
  },
  layout5: () => import('../iconify-icons/mingcute/layout-5-line.js'),
  announce: {
    module: () => import('../iconify-icons/mingcute/announcement-line.js'),
    rtl: true,
  },
  alert: () => import('../iconify-icons/mingcute/alert-line.js'),
  round: () => import('../iconify-icons/mingcute/round-fill.js'),
  'round-line': () => import('../iconify-icons/mingcute/round-line.js'),
  'arrow-up-circle': () =>
    import('../iconify-icons/mingcute/arrow-up-circle-line.js'),
  'arrow-down-circle': () =>
    import('../iconify-icons/mingcute/arrow-down-circle-line.js'),
  clipboard: {
    module: () => import('../iconify-icons/mingcute/clipboard-line.js'),
    rtl: true,
  },
  'account-edit': () => import('../iconify-icons/mingcute/user-edit-line.js'),
  'account-warning': () =>
    import('../iconify-icons/mingcute/user-warning-line.js'),
  'account-add': () => import('../iconify-icons/mingcute/user-add-2-line.js'),
  keyboard: () => import('../iconify-icons/mingcute/keyboard-line.js'),
  cloud: () => import('../iconify-icons/mingcute/cloud-line.js'),
  month: {
    module: () => import('../iconify-icons/mingcute/calendar-month-line.js'),
    rtl: true,
  },
  media: () => import('../iconify-icons/mingcute/photo-album-line.js'),
  speak: () => import('../iconify-icons/mingcute/radar-line.js'),
  building: () => import('../iconify-icons/mingcute/building-5-line.js'),
  history2: {
    module: () => import('../iconify-icons/mingcute/history-2-line.js'),
    rtl: true,
  },
  document: () => import('../iconify-icons/mingcute/document-line.js'),
  'arrows-right': {
    module: () => import('../iconify-icons/mingcute/arrows-right-line.js'),
    rtl: true,
  },
  code: () => import('../iconify-icons/mingcute/code-line.js'),
  copy: () => import('../iconify-icons/mingcute/copy-2-line.js'),
  quote: {
    module: () => import('../iconify-icons/mingcute/quote-left-fill.js'),
    rtl: true,
  },
  quote2: {
    module: () => import('../iconify-icons/mingcute/blockquote-line.js'),
    rtl: true,
  },
  settings: () => import('../iconify-icons/mingcute/settings-6-line.js'),
  'heart-break': () => import('../iconify-icons/mingcute/heart-crack-line.js'),
  'user-x': () => import('../iconify-icons/mingcute/user-x-line.js'),
  minimize: () => import('../iconify-icons/mingcute/down-line.js'),
  celebrate: () => import('../iconify-icons/mingcute/celebrate-line.js'),
  schedule: () => import('../iconify-icons/mingcute/calendar-time-add-line.js'),
  day: () => import('../iconify-icons/mingcute/calendar-day-line.js'),
  camera: () => import('../iconify-icons/mingcute/camera-line.js'),
  endorsement: {
    module: () => import('../iconify-icons/mingcute/user-star-line.js'),
    rtl: true,
  },
  formula: () => import('../iconify-icons/mingcute/formula-line.js'),
  edit: () => import('../iconify-icons/mingcute/edit-4-line.js'),
  'zoom-in': () => import('../iconify-icons/mingcute/zoom-in-line.js'),
  'zoom-out': () => import('../iconify-icons/mingcute/zoom-out-line.js'),
  'cursor-hand': () =>
    import('../iconify-icons/mingcute/hand-finger-2-line.js'),
  qrcode: () => import('../iconify-icons/mingcute/qrcode-2-line.js'),
  scan: () => import('../iconify-icons/mingcute/scan-line.js'),
  note: () => import('../iconify-icons/mingcute/document-3-line.js'),
  grid: () => import('../iconify-icons/mingcute/grid-line.js'),
  moon: {
    module: () => import('../iconify-icons/mingcute/moon-line.js'),
    flip: 'horizontal',
  },
  'arrow-up-top': () => import('../iconify-icons/mingcute/arrow-to-up-line.js'),
  collections: () => import('../iconify-icons/mingcute/board-line.js'),
};
